import {
  DollarSign,
  HeartHandshake,
  MonitorCheck,
  MonitorDown,
  Rss,
  Sparkles,
} from "lucide-react";

export const faqs = [
  {
    title: "Installations",
    question: "How do I install the plugin?",
    icon: (
      <MonitorDown className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "https://youtu.be/-o0wz_28QLk",
    content: () => {
      return (
        <p>
          Installing Whizmanage is simple, even if you have no technical background. Simply watch the video and follow the instructions. You can find the link to the video in the top right corner of this answer card.
        </p>
      );
    },
  },
  {
    title: "Update",
    question: "How do I update a version?",
    icon: (
      <Rss className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "https://youtu.be/Qz_HEoTVpco",
    content: () => {
      return (
        <div>
          <p>Simply watch the video and follow the instructions. Our interface provides notifications for new version updates. You will receive direct links to download the latest updates. Check the top right corner of this answer card for the video link.</p>
        </div>
      );
    },
  },
  {
    title: "Advantages",
    question:
      "What makes Whizmanage better than other Woocommerce or automation platforms?",
    icon: (
      <Sparkles className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "",
    content: () => {
      return (
        <p>
          Whizmanage was designed smart and simple, with minimal buttons and clear icons, making mistakes unlikely. You can also watch the User’s Guide video, which includes screenshots of every feature.
        </p>
      );
    },
  },
  {
    title: "Ease of Use",
    question:
      "How do I perform what needs to be done without making many mistakes?",
    icon: (
      <HeartHandshake className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "",
    content: () => {
      return (
        <p>
          Whizmanage was designed smart and simple, with minimal buttons and clear icons, making mistakes unlikely. You can also watch the User’s Guide video, which includes screenshots of every feature.
        </p>
      );
    },
  },
  {
    title: "Pricing",
    question: "Is Whizmanage free to use?",
    icon: (
      <DollarSign className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "internal",
    content: () => {
      return (
        <p>
          Whizmanage offers multiple versions, including a free version with a wide range of useful features for managing your store. Click the link in the top right corner of this answer card to view all available options and their differences.
        </p>
      );
    },
  },
  {
    title: "Compatibility",
    question: "Can the plugin be installed in all websites?",
    icon: (
      <MonitorCheck className="size-6 rounded-lg text-fuchsia-600/50 group-hover:text-fuchsia-700" />
    ),
    ctaLink: "",
    content: () => {
      return (
        <p>
          Whizmanage is only compatible with WordPress sites that use WooCommerce.
        </p>
      );
    },
  },
];
